<script lang="ts">
import { SearchFilters } from '../../search/schemas'
import { SearchFiltersUrl } from '../../url/search-filters/SearchFiltersUrl'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import GenericLink from '../link-generic/GenericLink'
import { GenericLinkData } from '../link-generic/GenericLinkData'
import { PuCampsiteLinkProps } from './PuCampsiteLinkProps'
import { routeToFilters } from '../infrastructure/routeToFilters'

@Component({
  mixins: [GenericLink],
})
class PuCampsiteLink extends Vue implements PuCampsiteLinkProps {
  @Prop({
    required: true,
    type: String,
    validator: (s: string) => s.length > 0,
  })
  hierarchyPath: string

  @Prop({
    required: true,
    type: String,
    validator: (s: string) => s.length > 0,
  })
  slug: string

  @Prop({ required: false, type: String })
  pitchtypeId: string

  @Prop({ required: false, type: Object, default: () => ({}) })
  filters: Partial<SearchFilters>

  @Prop({ required: false, default: 'campsite' })
  excludeType: string

  @Prop({ required: false, type: String })
  reviewId?: string

  @Prop({ default: false, type: Boolean })
  forceReviewId: boolean

  @Prop({ default: true })
  prependUrlSearchFilters: boolean

  @Prop({ default: () => [] })
  forceQueryParams: string[]

  @Prop({ default: () => [] })
  excludeQueryParams: string[]

  @Prop({ type: String })
  hash?: string

  @Prop({ default: false })
  forceNoFilters: boolean

  get linkData(): GenericLinkData {
    const path = this.hierarchyPath
    return {
      query: {
        // @ts-expect-error TODO: Type SearchFiltersUrl.filtersToUrl return value to include query property
        ...SearchFiltersUrl.filtersToUrl(this.queryFilters).query,
        pitchtype: this.pitchtypeId || undefined,
        review: this.reviewId,
      },
      path: `/campsites/${path}${this.slug}/`,
      forceQueryParams: this.forceReviewId
        ? this.forceQueryParams.concat(['review'])
        : this.forceQueryParams,
      excludeQueryParams: this.excludeQueryParams,
      hash: this.hash ?? this.reviewHash,
    }
  }

  private get queryFilters() {
    if (this.forceNoFilters) {
      return {}
    }
    const filters = routeToFilters(this.$route)
    return this.prependUrlSearchFilters
      ? {
          ...filters,
          ...this.filters,
        }
      : { ...this.filters }
  }

  private get reviewHash() {
    return this.reviewId && this.forceReviewId
      ? `#reviews_${this.reviewId}`
      : undefined
  }
}

export default toNative(PuCampsiteLink)
</script>
